import { Observable } from 'rxjs';

import { SnMapView } from '@lib/api/entities';
import { IFsMap } from '@lib/geo/core';

export abstract class FsMapIncidentManagementServiceProvider<
  TMap extends IFsMap,
  TDirectionsRoute,
  TMarker,
  TOverlayType,
  TRoutePolyline,
  TShape = any,
  TCombined = TShape | TMarker,
> {
  public abstract addToDirections: any[];
  public abstract canChange: boolean;
  public abstract clickoutHandler: (event: unknown) => void;
  public abstract currentView: SnMapView;
  public abstract existingRoute: TDirectionsRoute[];
  public abstract isAddingDirection: boolean;
  public abstract isAddingNotes: boolean;
  public abstract isDrawing: boolean;
  public abstract map: TMap;
  public abstract routeResults: TDirectionsRoute[];
  public abstract shapes: { shape: TCombined; data: any }[];
  public abstract totalDistance: number;
  public abstract totalRouteTime: number;

  public abstract activeFillColor: string;
  public abstract activeStrokeColor: string;
  public abstract isDeleting: boolean;
  public abstract isLoadingVectors: boolean;
  public abstract fillOpacity: number;
  public abstract strokeOpacity: number;
  public abstract strokeWeight: number;

  public abstract get shapeComplete$(): Observable<TCombined>;
  public abstract get shouldDisableShapeCreation(): boolean;
  public abstract get routePolyline(): TRoutePolyline;

  public abstract onMapLoaded(googleMap: TMap): void;
  public abstract setCurrentView(view: SnMapView): void;
  public abstract removeTab(view: SnMapView): void;
  public abstract updateTab(view: SnMapView): void;
  public abstract selectDirectionMarkers(): void;
  public abstract setDrawingMode(drawingMode?: TOverlayType): void;
  public abstract getDrawingMode(): TOverlayType;
  public abstract enterDrawingMode(): void;
  public abstract leaveDrawingMode(reset: boolean): void;
  public abstract clearShapes(): void;
  public abstract editShapes(): void;
  public abstract setMarker(marker: TMarker): void;
  public abstract addShape(type: string): void;
  public abstract saveShape(shape: TCombined, data: any): void;
  public abstract deleteShape(shape?: TCombined): void;
  public abstract isActiveShape(type: string): boolean;
  public abstract generateRoute(): void;
  public abstract checkIconRoutes(): void;
  public abstract saveRoute(addToDirections: any[]): Observable<SnMapView>;
}
